import { Link } from "@tanstack/react-router";
import type { Item } from "../../lib/api/models";
import { formatDay } from "../../lib/format";

/**
 * Devices, or network equipment and printers, as a table: the name and the five asset fields of Gorelo sync §6.2
 * (manufacturer, model, serial number, warranty start and end), then the site. A row opens the item.
 */
export function ItemsTable({ clientId, items, label }: { clientId: string; items: Item[]; label: string }) {
  return (
    <div className="overflow-x-auto">
      <table aria-label={label} className="kd-datatable min-w-[760px]">
        <thead>
          <tr>
            <th>Name</th>
            <th>Manufacturer</th>
            <th>Model</th>
            <th>Serial number</th>
            <th>Warranty start</th>
            <th>Warranty end</th>
            <th>Site</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <tr key={it.id}>
              <td>
                <Link
                  to="/clients/$clientId/items/$itemId"
                  params={{ clientId, itemId: it.id }}
                  className="font-semibold text-ink hover:text-green-ink"
                >
                  {it.name}
                </Link>
              </td>
              <td>{it.manufacturer}</td>
              <td>{it.model}</td>
              <td className="font-mono text-xs text-ink">{it.serial}</td>
              <td className="tabular-nums">{formatDay(it.warrantyStart)}</td>
              <td className="tabular-nums">{formatDay(it.warrantyEnd)}</td>
              <td>{it.siteName || <span className="text-ink-3">No site</span>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
